<div class="content-page">
    <!-- <div class="row g-0">
        <div class="col-4 bg-aside"> -->
            <app-aside messageBackground="Entre na sua conta para contratar um empréstimo consignado ou  ver contratos ativos"></app-aside>
        <!-- </div>
        <div class="col-8"> -->
            <main>
                <!-- <br>
                <app-btn-whatsapp></app-btn-whatsapp>
                <br> <br>
                <app-btn-sac></app-btn-sac> -->
                <!-- <button mat-flat-button color="primary" (click)="openHelpDelinquentModal()">jhbhb
                    <div class="test">

                    </div>
                </button> -->

                <!-- <button (click)="listar()">OOOIEEEEEE</button>

                <br>
                <-- <div class="" container-items>
                    <ul>
                        <li *ngFor="let item of this.ambientes">
                            <h1>{{this.buttons}}</h1>
                        </li>
                     </ul>
                     dghdf
                  </div> -->

                <!-- <button mat-flat-button color="primary" (click)="openBB()">AQUI HEY</button>
                
                Aqui conteúdo

                <br> 
                  <app-sac-contact-link></app-sac-contact-link>
                  <br>
                  <app-btn-whatsapp-border></app-btn-whatsapp-border>
                <br>
                <br>

                <button mat-flat-button color="primary" (click)="openSnackBar()">AQUI</button>
                <button mat-flat-button color="primary" (click)="openSnackBarInvalid()">ALERT INVALID TOKEN</button>
                <br><br><br>
                <br>
                <button mat-flat-button color="warn" (click)="openDialog()">Dialog in rules</button>
                <br>
                <button mat-raised-button color="accent" (click)="openDialogTwoButton()">MODAL MODELO TWO BUTTON</button>
                <h1>OI</h1>
                <button mat-raised-button color="primary" (click)="openDialogContact()">Modal Contact</button>
                <br>
                <button mat-raised-button color="accent" (click)="openDialogTxt()">Modal TXT</button>
                <br>
                <button mat-raised-button color="warn" (click)="openDialogPassword()">Modal Password</button> -->

                <!-- <button mat-raised-button color="primary" (click)="openDialogContact()">Modal Contact</button> -->
                
                <app-footer></app-footer>  

            </main>          
        <!-- </div>
    </div> -->
</div>
